import PicklistMetadata from "../PicklistMetadata";

class ProjectPlanPhaseMilestoneReferencePicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "ProjectPlanPhaseMilestoneReference";
        this.bounded = true;
        this.enterpriseComponent = "ProjectPlanPhaseMilestoneReferenceLookup";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.useRealm = false;
        this.searchSpecification = null;
        this.sortSpecification = null;
        this.static = false;
        this.typeField = "DocumentIDPlusRevision";
        this.typeValue = "USID";
        this.typeValue2 = null;
        this.visibilityType = null;
    }
}

export default ProjectPlanPhaseMilestoneReferencePicklistMetadata;
